// extracted by mini-css-extract-plugin
module.exports = {"TitleSection":"CreateAccount__TitleSection__RXY5","tamañoForm":"CreateAccount__tamañoForm__1k8F","ident":"CreateAccount__ident__-EU8"};